module.exports = require('./lower-case');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/string/lc.js
// module id = 282
// module chunks = 0 1 2